import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

/**
 * Estado vacío genérico para los tabs del dashboard.
 */
export function EmptyState({ icon: Icon, title, description, ctaLabel, ctaTo, ctaOnClick, testId }) {
  return (
    <Card
      data-testid={testId}
      className="p-6 sm:p-8 rounded-2xl bg-white border border-dashed border-[var(--ns-border-strong)] text-center"
    >
      {Icon ? (
        <div className="h-12 w-12 rounded-2xl bg-[var(--ns-amber-50)] text-[var(--ns-gold-700)] inline-flex items-center justify-center mx-auto mb-3">
          <Icon className="h-5 w-5" />
        </div>
      ) : null}
      <h3 className="font-display uppercase tracking-wide text-lg text-[var(--ns-text)]">{title}</h3>
      {description ? (
        <p className="text-sm text-[var(--ns-text-muted)] mt-1.5 max-w-md mx-auto">{description}</p>
      ) : null}
      {ctaLabel ? (
        ctaTo ? (
          <Button
            asChild
            className="mt-4 h-10 px-5 rounded-xl bg-gradient-to-r from-[var(--ns-gold)] to-[var(--ns-gold-600)] text-[#1c1612] font-semibold hover:from-[var(--ns-gold-600)] hover:to-[var(--ns-gold-700)] hover:text-white hover:shadow-[var(--ns-glow-gold)] border-0 transition-all"
          >
            <Link to={ctaTo}>{ctaLabel}</Link>
          </Button>
        ) : (
          <Button
            onClick={ctaOnClick}
            className="mt-4 h-10 px-5 rounded-xl bg-gradient-to-r from-[var(--ns-gold)] to-[var(--ns-gold-600)] text-[#1c1612] font-semibold hover:from-[var(--ns-gold-600)] hover:to-[var(--ns-gold-700)] hover:text-white hover:shadow-[var(--ns-glow-gold)] border-0 transition-all"
          >
            {ctaLabel}
          </Button>
        )
      ) : null}
    </Card>
  );
}
